import React from "react";

const PrescriptionV2 = React.createContext();

export default PrescriptionV2;
